import dayjs from 'dayjs';

import { BetEventFormValues } from './types';

export const INITIAL_BET_EVENT_VALUES: BetEventFormValues = {
  name: '',
  imageId: null,
  streamLink: null,
  hasSingleBet: false,
  startDate: dayjs(),
  actionText: 'Смотреть и анализировать',
};
